import NiceModal from "@ebay/nice-modal-react";
import MemberSignTabModal from "modals/member/sign/MemberSignTabModal";
import PaymentModal from "routes/order/summary/PaymentModal";
import SideMenu from "modals/sideMenu/SideMenu";
import ShippingInfoAddModal from "modals/member/shippingInfo/ShippingInfoAddModal";
import Filter from "modals/filter/Filter";
import ReviewModal from "modals/detail/ReviewModal";
import ReviewModifyModal from "modals/detail/ReviewModifyModal";
import ConfirmModal from "modals/confirm/ConfirmModal";
import AddCartCountModal from "modals/cart/AddCartCountModal";
import SearchModal from "modals/search/SearchModal";
import QuestionModal from "modals/question/QuestionModal";
import AnswersModal from "modals/question/answer/AnswersModal";
import ShippingInfoSelectModal from "modals/member/shippingInfo/ShippingInfoSelectModal";
import ShippingInfoEditModal from "modals/member/shippingInfo/ShippingInfoEditModal";
import PaymentMethodSelectModal from "modals/member/paymentMethod/PaymentMethodSelectModal";
import TrackOrderModal from "modals/order/TrackOrderModal";
import ProductManagerModal from "modals/manager/ProductManagerModal";
import EditorPreviewModal from "modals/manager/EditorPreviewModal";
import DisputeModal from "modals/dispute/DisputeModal";
import NextDisputeModal from "modals/dispute/NextDisputeModal";
import AccountVerificationModal from "modals/accountVerification/AccountVerificationModal";
import NextVerificationModal from "modals/accountVerification/NextVerificationModal";
import AccountDisabledModal from "modals/accountDisabled/AccountDisabledModal";
import MemberSignInModal from "modals/member/sign/signIn/MemberSignInModal";
import PurchaseOrderModal from "modals/order/PurchaseOrderModal";
import AddressModal from "modals/address/AddressModal";
import AddressCityModal from "modals/address/AddressCityModal";
import LoginHistoryModal from "modals/loginHistory/LoginHistoryModal";
import WarningModal from "modals/warning/WarningModal";
import ShippingInfoDetailModal from "modals/shippingInfo/ShippingInfoDetailModal";
import ShippingInfoUpdateModal from "modals/shippingInfo/update/ShippingInfoUpdateModal";
import AllCartsInfoDetailModal from "modals/cart/admin/AllCartsInfoDetailModal";
import ChatModal from "modals/chat/ChatModal";
import CategoryRegisterModal from "modals/category/CategoryRegisterModal";
import AddProductOptionModal from "modals/product/AddProductOptionModal";
import MemoModal from "modals/memo/MemoModal";
import PurchaseOrderShippingInfoEditModal from "modals/order/PurchaseOrderShippingInfoEditModal";
import BrandRegisterModal from "modals/category/BrandRegisterModal";
import AdminPurchaseOrderModal from "modals/order/AdminPurchaseOrderModal";
import AddressKrModal from "modals/address/kr/AddressKrModal";
import VendorRegModal from "modals/manager/VendorRegModal";
import ReturnCancelConfirmModal from "modals/confirm/ReturnCancelConfirmModal";
import CheckSelectModal from "modals/manager/CheckSelectModal";
import ProductStatusModal from "modals/product/ProductStatusModal";
import ExhibitionDetailModal from "modals/exhibition/ExhibitionDetailModal";
import PromotionDetailModal from "modals/promotion/PromotionDetailModal";
import CheckSelectProductModal from "modals/manager/CheckSelectProductModal";
import SelectedProductModal from "modals/product/SelectedProductModal";
import ShippingInfoAddKrModal from "modals/member/shippingInfo/ShippingInfoAddKrModal";
import OptionRegisterModal from "modals/option/OptionRegisterModal";
import PromotionEditModal from "modals/promotion/PromotionEditModal";
import AdminCheckSelectModal from "modals/manager/AdminCheckSelectModal";
import CategoryEditModal from "modals/category/CategoryEditModal";
import VariantStatusModal from "modals/product/VariantStatusModal";
import MainDisplayModal from "modals/product/MainDisplayModal";
import ConfirmSelectModal from "modals/confirm/ConfirmSelectModal";
import CustomerStatusModal from "modals/customer/CustomerStatusModal";
import passwordChangeModal from "modals/customer/passwordChangeModal";
import ArticleDetailModal from "modals/article/ArticleDetailModal";
import BoardDetailModal from "modals/article/BoardDetailModal";
import OpenImageModal from "modals/manager/OpenImageModal";
import ShowDataModal from "modals/statistic/ShowDataModal";
import SupportDetailModal from "modals/support/SupportDetailModal";
import MobileAddCartModal from "modals/cart/MobileAddCartModal";
import BannerDetailModal from "modals/detail/BannerDetailModal";
import CustomerPasswordChangeModal from "modals/customer/CustomerPasswordChangeModal";
import OrderDetailModal from "modals/order/OrderDetailModal";
import CustomerEditModal from "modals/customer/CustomerEditModal";
import ShowModal from "modals/manager/ShowModal";
import PointModal from "modals/member/PointModal";
import AddPointModal from "modals/member/AddPointModal";

function ModalHandler() {
  NiceModal.register("memberSignTabModal", MemberSignTabModal);
  NiceModal.register("memberSignIn", MemberSignInModal);
  NiceModal.register("paymentModal", PaymentModal);
  NiceModal.register("sideMenu", SideMenu);
  NiceModal.register("shippingInfoAddModal", ShippingInfoAddModal);
  NiceModal.register("shippingInfoAddKrModal", ShippingInfoAddKrModal);
  NiceModal.register("shippingInfoSelectModal", ShippingInfoSelectModal);
  NiceModal.register("shippingInfoEditModal", ShippingInfoEditModal);
  NiceModal.register(
    "purchaseOrderShippingInfoEditModal",
    PurchaseOrderShippingInfoEditModal
  );
  NiceModal.register("filter", Filter);
  NiceModal.register("review", ReviewModal);
  NiceModal.register("bannerDetail", BannerDetailModal);
  NiceModal.register("reviewModify", ReviewModifyModal);
  NiceModal.register("confirm", ConfirmModal);
  NiceModal.register("confirmSelect", ConfirmSelectModal);
  NiceModal.register("passwordChange", passwordChangeModal);
  NiceModal.register("customerPasswordChange", CustomerPasswordChangeModal);
  NiceModal.register("returnCancelConfirm", ReturnCancelConfirmModal);
  NiceModal.register("addCartCount", AddCartCountModal);
  NiceModal.register("mobileAddCart", MobileAddCartModal);
  NiceModal.register("search", SearchModal);
  NiceModal.register("questions", QuestionModal);
  NiceModal.register("answers", AnswersModal);
  NiceModal.register("paymentMethodSelectModal", PaymentMethodSelectModal);
  NiceModal.register("trackOrder", TrackOrderModal);
  NiceModal.register("purchaseOrder", PurchaseOrderModal);
  NiceModal.register("adminPurchaseOrder", AdminPurchaseOrderModal);
  NiceModal.register("productManagerModal", ProductManagerModal);
  NiceModal.register("editorPreviewModal", EditorPreviewModal);
  NiceModal.register("dispute", DisputeModal);
  NiceModal.register("nextDispute", NextDisputeModal);
  NiceModal.register("accountVerification", AccountVerificationModal);
  NiceModal.register("nextVerification", NextVerificationModal);
  NiceModal.register("accountDisabled", AccountDisabledModal);
  NiceModal.register("address", AddressModal);
  NiceModal.register("addressCity", AddressCityModal);
  NiceModal.register("loginHistory", LoginHistoryModal);
  NiceModal.register("warning", WarningModal);
  NiceModal.register("shippingInfoDetail", ShippingInfoDetailModal);
  NiceModal.register("shippingInfoUpdate", ShippingInfoUpdateModal);
  NiceModal.register("allCartsInfoDetail", AllCartsInfoDetailModal);
  NiceModal.register("chat", ChatModal);
  NiceModal.register("categoryRegister", CategoryRegisterModal);
  NiceModal.register("categoryEdit", CategoryEditModal);
  NiceModal.register("mainDisplay", MainDisplayModal);
  NiceModal.register("optionRegister", OptionRegisterModal);
  NiceModal.register("brandRegister", BrandRegisterModal);
  NiceModal.register("productOption", AddProductOptionModal);
  NiceModal.register("memo", MemoModal);
  NiceModal.register("addressKr", AddressKrModal);
  NiceModal.register("vendorReg", VendorRegModal);
  NiceModal.register("checkSelect", CheckSelectModal);
  NiceModal.register("openImage", OpenImageModal);
  NiceModal.register("checkSelectProduct", CheckSelectProductModal);
  NiceModal.register("adminCheckSelect", AdminCheckSelectModal);
  NiceModal.register("show", ShowModal);
  NiceModal.register("productStatus", ProductStatusModal);
  NiceModal.register("variantStatus", VariantStatusModal);
  NiceModal.register("customerStatus", CustomerStatusModal);
  NiceModal.register("customerEdit", CustomerEditModal);
  NiceModal.register("exhibitionDetail", ExhibitionDetailModal);
  NiceModal.register("promotionDetail", PromotionDetailModal);
  NiceModal.register("promotionEdit", PromotionEditModal);
  NiceModal.register("selectedProduct", SelectedProductModal);
  NiceModal.register("articleDetail", ArticleDetailModal);
  NiceModal.register("boardDetail", BoardDetailModal);
  NiceModal.register("showData", ShowDataModal);
  NiceModal.register("supportDetail", SupportDetailModal);
  NiceModal.register("mobileAddCart", MobileAddCartModal);
  NiceModal.register("orderDetail", OrderDetailModal);
  NiceModal.register("point", PointModal);
  NiceModal.register("addPoint", AddPointModal);
}

export default ModalHandler;
